import {
  getProjects,
  getProjectsHierarchy,
  createProject,
  updateProject,
} from '@/api';

const localState = {
  projects: [],
  currentProject: null,
  projectsHierarchy: null,
};

const getters = {
  currentProject: state => state.currentProject,
};

const actions = {
  async initProjects({ commit, dispatch }) {
    const res = await getProjects();
    const { projects } = res.data;
    commit('setProjects', { projects });

    // 直接进入项目主页需要设置
    const localProject = JSON.parse(localStorage.getItem('currentProject'));
    const project = projects.find(p => p.id === (localProject && localProject.id)) || projects[0];
    if (project) {
      await dispatch('changeProject', { project });
    }
  },
  async changeProject({ commit, dispatch }, { project }) {
    commit('setProject', { project });

    // 获取并设置全局 deviceStates、Branches、menus
    await Promise.all([
      dispatch('device/initDeviceStates', {}, { root: true }),
      dispatch('group/initBranchs', {}, { root: true }),
      dispatch('menu/initMenus', {}, { root: true }),
    ]);
  },
  async createProject({ commit }, body) {
    const res = await createProject(body);
    const { project } = res.data;
    commit('addProject', { project });
  },
  async updateProject({ commit }, body) {
    const res = await updateProject(body);
    const { project } = res.data;
    commit('updateProject', { project });
  },
  async findOrGetProjectsHierarchy({ state, commit }) {
    if (state.projectsHierarchy) return state.projectsHierarchy;

    const res = await getProjectsHierarchy();
    const { code, msg, projects } = res.data;
    if (code !== 0) throw new Error(msg);

    commit('setProjectsHierarchy', { projects });
    return projects;
  },
};

const mutations = {
  setProjects(state, { projects }) {
    state.projects = projects;
  },
  // 切换项目提交
  setProject(state, { project }) {
    localStorage.setItem('currentProject', JSON.stringify(project));
    state.currentProject = project;
  },
  // 修改项目信息提交
  updateProject(state, { project }) {
    const currentProject = state.projects.find(p => p.id === project.id);
    if (currentProject) {
      Object.assign(currentProject, project);
      localStorage.setItem('currentProject', JSON.stringify(currentProject));
    }
  },
  addProject(state, { project }) {
    state.projects.push(project);
  },
  deleteProject(state, { project }) {
    const index = state.projects.findIndex(p => p.id === project.id);
    if (index !== -1) {
      state.projects.splice(index, 1);
      const currentProject = JSON.parse(localStorage.getItem('currentProject'));
      if (project.id === currentProject.id) {
        localStorage.removeItem('currentProject');
        state.currentProject = null;
      }
    }
  },
  setProBannerNull(state) {
    const { currentProject } = state;
    Object.assign(currentProject, { bannerUrl: null });
    localStorage.setItem('currentProject', JSON.stringify(currentProject));
  },
  setProjectsHierarchy(state, { projects }) {
    state.projectsHierarchy = projects;
  },
};

export default {
  actions,
  mutations,
  getters,
  state: localState,
  namespaced: true,
};

